import { makeStyles } from 'tss-react/mui'
import { Theme } from '@mui/material/styles'

import { StylesProps } from '../types/interface/styles.interface'

export const useMobileStyles = makeStyles<StylesProps>()((theme: Theme, props) => ({
  headerWrapper: {
    padding: '30px 20px',
    background: `center url(${props.backgroundImage}) no-repeat`,
    borderRadius: '0 0 30% 0',
  },

  logoWrapper: {
    display: 'flex',
    flex: 0,
    marginTop: theme.spacing(3),
  },

  logoImage: {
    alignSelf: 'start',
    height: props.logoImageHeight ? props.logoImageHeight : '28px',
  },
}))
